import { render, staticRenderFns } from "./_error.vue?vue&type=template&id=a7a97604&scoped=true"
import script from "./_error.vue?vue&type=script&lang=js"
export * from "./_error.vue?vue&type=script&lang=js"
import style0 from "./_error.vue?vue&type=style&index=0&id=a7a97604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a97604",
  null
  
)

export default component.exports